import React from "react";

function Hero() {
  return (
  <>
    <section className="hero-title-section">
      <div className="hero-title-inner">
        <h1 className="hero-title">CofounderHubs</h1>
        <p className="hero-subtitle">
          Find the co-founder you've been looking for in no time.
        </p>
      </div>
    </section>
    <section>
      <img
        className="hero-image"
        src="./img/business-handshake.jpg"
        alt="Two business professionals shaking hands for their startup partnership"
      />
    </section>
  </>
  );
}

export default Hero;
